;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('zlSnackbar', SnackbarDirective)

  SnackbarController.$inject = ['$timeout']

  /**
   * Controller for common Snackbar directive
   * @access private
   * @param $scope
   * @param DisplayService
   * @constructor SnackbarController
   */
  function SnackbarController ($timeout) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        active: true
      })
      init()
    }

    function init () {
      /**
       *
       */
      var active = true

      /**
       *
       */
      var delay = self.delay ? self.delay : 5000

      $timeout(function () {
        self.active = false
      }, self.delay)
    }
  }

  SnackbarDirective.$inject = []

  /**
   * Common directive used to create a list to select an item
   * @type Directive
   * @returns {{restrict: string, templateUrl: string, controller: SpinnerController, controllerAs: string, link: link, scope: {items: string, onSelect: string}}}
   * @constructor
   */
  function SnackbarDirective () {
    return {
      restrict: 'E',
      templateUrl: '/app/common/directives/snackbar/snackbar.html',
      controller: SnackbarController,
      controllerAs: 'snack',
      replace: true,
      scope: {},
      bindToController: {
        text: '=',
        action: '&',
        actionText: '=',
        color: '=?',
        delay: '='
      }
    }
  }
})(window.angular, window._)
